/**
 * The Administration audit log's category chip for an entity type. Mirrors the
 * backend filter (zephix-backend src/admin/audit-event-category.ts), so a row
 * found by the Governance filter is also labelled Governance.
 *
 * D-211: gate submissions are Governance. A blocked or recorded gate decision
 * is written against `phase_gate_submission`; it used to fall through to Other.
 */
export function inferEventCategory(entityType: string): string {
  const et = entityType.toLowerCase();
  if (et === "user" || et === "email_verification") return "Auth";
  if (et === "work_task" || et === "board_move") return "Task";
  if (et === "project" || et === "portfolio") return "Project";
  if (
    [
      "work_risk",
      "entitlement",
      "billing_plan",
      "scenario_plan",
      "scenario_action",
      "scenario_result",
      "baseline",
      "capacity_calendar",
      "phase_gate_submission",
    ].includes(et)
  ) {
    return "Governance";
  }
  if (["organization", "workspace", "webhook", "attachment", "doc"].includes(et)) {
    return "Admin";
  }
  return "Other";
}
